import { Stack, Typography } from '@mui/material';
import { Image } from 'app/components';
import React, { useMemo } from 'react';

const AuthenticationLayout = (props) => {
  const { children } = props;

  const currentYear = useMemo(() => {
    return moment().format('YYYY');
  }, []);

  return (
    <Stack
      direction='row'
      sx={{
        height: '100vh',
        img: {
          width: '100%',
          height: '100%',
          objectFit: 'cover',
        },
      }}>
      <Stack
        direction='column'
        justifyContent='space-between'
        sx={{
          width: '100%',
          height: '100%',
          maxWidth: '480px',
          bgcolor: 'background.paper',
        }}>
        <Stack
          direction='column'
          sx={{
            width: '100%',
            maxWidth: '400px',
            marginLeft: 'auto',
            marginRight: 'auto',
            paddingLeft: '24px',
            paddingRight: '24px',
            paddingTop: '40px',
            paddingBottom: '28px',
            '.MuiTypography-h4': {},
            img: {
              width: '36px',
              height: '40px',
            },
          }}>
          <Image name='logo.svg' alt='logo' />
          <Typography variant='h4'>PROTRACKS</Typography>
        </Stack>
        <Stack
          direction='column'
          justifyContent='center'
          sx={{
            width: '100%',
            maxWidth: '400px',
            height: '100%',
            paddingLeft: '24px',
            paddingRight: '24px',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}>
          {children}
        </Stack>
        <Typography
          variant='body1'
          sx={{
            paddingTop: '28px',
            paddingBottom: '40px',
            paddingLeft: '24px',
            paddingRight: '24px',
            width: '100%',
            maxWidth: '400px',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}>
          © {currentYear} Digital Technologies, Inc.
        </Typography>
      </Stack>
      <Stack direction='row'>
        <Image name='authentication-layout.jpg' alt='authentication-layout' />
      </Stack>
    </Stack>
  );
};

export default AuthenticationLayout;
